import {InjectionToken} from "@angular/core";
import {CashHardwarePort} from "../ports/cash-hardware.port";

export const CASH_HARDWARE = new InjectionToken<CashHardwarePort>('CASH_HARDWARE');
